import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { formatIDR } from "@/lib/constants";

function rowProjectLabel(pc) {
  if (pc.project_type === "variation_order") return `${pc.project_name} · VO ${pc.project_variation || ""}`.trim();
  if (pc.project_type === "working_order") return `${pc.project_name} · WO ${pc.project_wo_number || ""}`.trim();
  return pc.project_name || "Untitled";
}

/** Approve / Reject a pending petty cash. */
export default function PettyCashReviewDialog({ open, pc, action, note, onNoteChange, onCancel, onSubmit }) {
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) onCancel(); }}>
      <DialogContent className="rounded-none max-w-md" data-testid="dlg-pc-review">
        <DialogHeader>
          <DialogTitle className="font-display text-xl">
            {action === "approve" ? "Approve" : "Reject"} Petty Cash
          </DialogTitle>
        </DialogHeader>
        {pc && (
          <div className="space-y-3 text-sm">
            <div>
              <div className="font-semibold text-slate-800">{pc.week_label} — {rowProjectLabel(pc)}</div>
              <div className="text-xs text-slate-500">Total: <span className="font-semibold">{formatIDR(pc.total)}</span></div>
            </div>
            <div>
              <label className="text-[10px] uppercase tracking-wider text-slate-500">Note (opsional)</label>
              <Textarea data-testid="input-pc-review-note" value={note} onChange={(e) => onNoteChange(e.target.value)} className="rounded-none mt-1 text-sm" rows={3} />
            </div>
          </div>
        )}
        <DialogFooter>
          <Button variant="outline" onClick={onCancel} className="rounded-none">Batal</Button>
          <Button
            data-testid="btn-confirm-pc-review"
            onClick={onSubmit}
            className={`rounded-none text-white ${action === "approve" ? "bg-emerald-600 hover:bg-emerald-700" : "bg-rose-600 hover:bg-rose-700"}`}
          >
            {action === "approve" ? "Approve" : "Reject"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
